import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../api/api";
import "../App.css";
import { User } from "lucide-react";
import { PageHeader } from "../components/em/ui";

const UsersManagement = ({ token }) => {
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    role: "member",
    created_at: "",
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token"); // make sure token is defined

      const res = await axios.get(`${API_URL}/api/auth/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUsers(res.data);
    } catch (err) {
      console.error("Error fetching users", err);
    }
  };

  const deleteUser = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      const token = localStorage.getItem("token"); // make sure token is defined

      await axios.delete(`${API_URL}/api/auth/users/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      fetchUsers(); // refresh the users list
    } catch (err) {
      console.error("Error deleting user", err);
      alert("Failed to delete user");
    }
  };

  const editUser = (user) => {
    setEditingUser(user);
    setForm({
      username: user.username,
      email: user.email,
      password: "",
      role: user.role,
      created_at: user.created_at
        ? new Date(user.created_at).toISOString().slice(0, 16)
        : "",
    });
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token"); // fetch token dynamically

      if (editingUser) {
        // Update existing user
        await axios.put(`${API_URL}/api/auth/users/${editingUser.id}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        // Create new user
        await axios.post(`${API_URL}/api/auth/users`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      // Reset form and editing state
      setForm({
        username: "",
        email: "",
        password: "",
        role: "member",
        created_at: "",
      });
      setEditingUser(null);

      // Refresh user list
      fetchUsers();
    } catch (err) {
      console.error("Error saving user", err);
      alert("Failed to save user");
    }
  };

  return (
    <div className="contentWrapper">
      <div className="user-wrap">
        <div className="user-list">
          <PageHeader
            icon={User}
            title="User Management"
            subtitle="Track, manage and analyse team attendance"
          />

          <div className="btn-wrap">
            <div className="search-item">
              <input
                className="search-icon"
                type="text"
                name="name"
                placeholder="Search"
              />
            </div>
          </div>

          <div className="set-cnt">
            <div className="resp-table">
              <table>
                <thead>
                  <tr>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.role}</td>
                      <td>
                        {user.created_at
                          ? new Date(user.created_at).toLocaleString()
                          : ""}
                      </td>
                      <td>
                        <button
                          onClick={() => editUser(user)}
                          className="edit-btn"
                        ></button>
                        <button
                          onClick={() => deleteUser(user.id)}
                          className="delete-btn"
                        ></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="usr-form">
          <h3> {editingUser ? "Update" : "Add"} User </h3>
          {editingUser !== null || editingUser === null ? (
            <form onSubmit={handleSubmit} className="user-form">
              <div className="form-wrap">
                <div className="form-item">
                  <label>Title</label>
                  <input
                    name="username"
                    placeholder="Username"
                    value={form.username}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-item">
                  <label>Email</label>
                  <input
                    name="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-item">
                  <label>Password</label>
                  <input
                    name="password"
                    type="password"
                    placeholder="Password"
                    value={form.password}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-item">
                  <label>Member</label>
                  <select name="role" value={form.role} onChange={handleChange}>
                    <option value="admin">Admin</option>
                    <option value="hr">HR</option>
                  </select>
                </div>
                <div className="form-item">
                  <button type="submit" className="btn-fill">
                    {editingUser ? "Update" : "Add"} User
                  </button>
                </div>
              </div>
            </form>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default UsersManagement;
